import { photo } from '@/lib/utils/img';
import { brand, regionAccent } from '@/lib/theme/tokens';

export type Region = {
  key: 'srinagar' | 'gulmarg' | 'pahalgam' | 'sonamarg' | 'doodhpathri' | 'gurez';
  /** Pin position on the SVG canvas, percentage of viewBox. */
  x: number;
  y: number;
  name: string;
  sub: string;
  count: number;
  season: string;
  color: string;
  image: string;
};

export type Experience = {
  title: string;
  sub: string;
  pricePerSlot: number;
  icon: 'mountain' | 'leaf' | 'tent';
};

export const REGIONS: Region[] = [
  { key: 'srinagar',    x: 38, y: 50, name: 'Srinagar',    sub: 'Dal Lake · Houseboats', count: 84, season: 'Year-round',    color: regionAccent.srinagar,    image: photo.boat        },
  { key: 'gulmarg',     x: 22, y: 40, name: 'Gulmarg',     sub: 'Skiing · Apharwat',     count: 42, season: 'Closing May',   color: regionAccent.gulmarg,     image: photo.skier       },
  { key: 'pahalgam',    x: 56, y: 64, name: 'Pahalgam',    sub: 'Lakes · Trek hub',      count: 71, season: 'Opening now',   color: regionAccent.pahalgam,    image: photo.meadow      },
  { key: 'sonamarg',    x: 68, y: 36, name: 'Sonamarg',    sub: 'Great Lakes',           count: 38, season: 'Opens June',    color: regionAccent.sonamarg,    image: photo.alpineRidge },
  { key: 'doodhpathri', x: 26, y: 62, name: 'Doodhpathri', sub: 'Camping · Meadows',     count: 19, season: 'Peak May–Jun',  color: regionAccent.doodhpathri, image: photo.campingTent },
  { key: 'gurez',       x: 72, y: 14, name: 'Gurez',       sub: 'Off-grid · Wild',       count: 12, season: 'Opens July',    color: regionAccent.gurez,       image: photo.valley      },
];

/** Sample experiences shown in the side panel. Identical shape per region for now. */
export const SAMPLE_EXPERIENCES: Experience[] = [
  { title: 'Featured trek',     sub: '6 days · Moderate', pricePerSlot: 16500, icon: 'mountain' },
  { title: 'Day hike',          sub: 'Single day · Easy', pricePerSlot: 1800,  icon: 'leaf'     },
  { title: 'Riverside camping', sub: '2 nights',          pricePerSlot: 4400,  icon: 'tent'     },
];

export const DEFAULT_REGION = 'pahalgam' as const;

/** Re-export so map components can stay decoupled from the tokens module. */
export { brand };
